import { Http } from "@/plugins/http.js";
import dayjs from "dayjs";

export class PatientsRepository {
  constructor() {
    this.http = Http;
  }
  async createPatient(data) {
    if (data.birthdate) {
      data.birthdate = dayjs(data.birthdate).format("YYYY-MM-DD");
    }
    // $request->validate([
    //     'surname' => 'required|string',
    //     'name' => 'required|string',
    //     'patronymic' => 'required|string',
    //     'birthdate' => 'required|date',
    //     'phone' => 'nullable|string',
    //     'email' => 'nullable|email',
    //     'sex' => ['nullable', 'int', Rule::in([1, 2])],
    //     'password' => 'nullable|string',
    //     'avatar' => 'nullable|image',

    //     'dms' => 'nullable|string',
    //     'organization_id' => 'nullable|number',
    //     'structure_id' => 'nullable|number',
    //     'position_id' => 'nullable|number',
    // ]);
    try {
      const response = await this.http.post("v1/customers/find-or-create", data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return { ok: true, data: response.data.data, exist: response.status === 200 };
    } catch (e) {
      console.log("PatientsRepository.createPatient", e.response);
      return {
        ok: false,
        data: e,
      };
    }
  }
  async updatePatient(data, id) {
    if (data.birthdate) {
      data.birthdate = dayjs(data.birthdate).format("YYYY-MM-DD");
    }

    try {
      const response = await this.http.post(`v1/customers/${id}`, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return { ok: true, data: response.data.data };
    } catch (e) {
      console.log("PatientsRepository.updatePatient", e.response);
      return {
        ok: false,
        data: e,
      };
    }
  }

  async setMisOrganization(patientId, newMisId, oldMisId) {
    const result = {
      ok: true,
      message: "",
    };
    if (oldMisId && oldMisId !== newMisId) {
      const res = await this.http.delete(`v1/clinics/${oldMisId}/customers/${patientId}`);
      if (!res.success) {
        result.ok = false;
        result.message = res.message;
      }
      return result;
    }
    if (newMisId) {
      const res = await this.http.post(`v1/clinics/${newMisId}/customers?customer_id=${patientId}`);
      if (!res.success) {
        result.ok = false;
        result.message = res.message;
      }
      return result;
    }
  }

  async getList(filter = {}) {
    try {
      const response = await this.http.get("v1/customers/potential-risks", {
        params: {
          sex: filter.sex || null,
          score_min: filter.score[0] || null,
          score_max: filter.score[1] || null,
          group: filter.healthGroup,
          condition: filter.workingCondition,
        },
      });
      return response.data.data;
    } catch (e) {
      console.log("PatientsRepository.getList", e.response);
    }

    return [];
  }
  async getAll(filter = {}) {
    try {
      const response = await this.http.get("v1/customers", {
        params: {
          page: filter.page || 1,
          limit: filter.limit ? (filter.limit > 0 ? filter.limit : 9999) : 10,
          sex: filter.sex || null,
          phone: filter.phone || null,
          fio: filter.fio || null,
          age_from: filter.age ? filter.age[0] : null,
          age_to: filter.age ? filter.age[1] : null,
          organization_id: filter.organization_id || null,
          email: filter.email || null,
          dms: filter.dms || null,
          search: filter.search || null,
          sort_by: filter.sort_by || null,
          sort_order: filter.sort_order || null,
          position: filter.position || null,
          snils: filter.snils || null,
        },
      });
      return response.data;
    } catch (e) {
      console.log("PatientsRepository.getList", e.response);
    }

    return [];
  }

  async getReferences() {
    const result = {
      sexList: [{ id: null, name: "Все" }],
      healthGroups: [],
      workingConditions: [],
      scoreRange: { min: 0, max: 100 },
    };

    try {
      const { data } = await this.http.get("v1/customers/potential-risks/references");

      result.sexList = [...result.sexList, ...data.sex_list];
      result.healthGroups = data.health_groups;
      result.workingConditions = data.working_conditions;
      result.scoreRange = data.score_range;
    } catch (e) {
      console.log("PatientsRepository.getReferences", e.response);
    }

    return result;
  }
}
